class GridColumn extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="grid-column">
          Grid & Column
          <span className="section__item-docs">
            Documentation: <a href="/docs/scss#mixins-mixin-grid" target="_blank">Grid</a> --&nbsp;
            <a href="docs/scss#mixins-mixin-column" target="_blank">Column</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Sample grid</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="grid-demo">
  <div class="col-3 column">Column 3</div>
  <div class="col-6 column">Column 6</div>
  <div class="col-12 column">Column 12</div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.grid-demo {
  @include grid();

  border: 1px solid $azure;
  margin: 0 auto;

  .column {
    background: transparentize($pink, .5);
    border: 1px solid $dark;
    color: $pink;
    text-align: center;
  }

  .col-3 {
    @include column(3);
  }

  .col-6 {
    @include column(6);
  }

  .col-12 {
    @include column(12);
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="grid-demo">
                    <div className="col-3 column">Column 3</div>
                    <div className="col-6 column">Column 6</div>
                    <div className="col-12 column">Column 12</div>
                  </div>
                </Output>
              </div>
            </div>
            <div className="demo">
              <h4 className="demo__title">Full column examples</h4>
              <div className="demo__code">
                <CodeBlock lang="html">{`
<div className="grid-demo-row">
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
  <div class="col-1 column">1</div>
</div>
<div className="grid-demo-row">
  <div class="col-2 column">2</div>
  <div class="col-2 column">2</div>
  <div class="col-2 column">2</div>
  <div class="col-2 column">2</div>
  <div class="col-2 column">2</div>
  <div class="col-2 column">2</div>
</div>
<div className="grid-demo-row">
  <div class="col-3 column">3</div>
  <div class="col-3 column">3</div>
  <div class="col-3 column">3</div>
  <div class="col-3 column">3</div>
</div>
<div className="grid-demo-row">
  <div class="col-4 column">4</div>
  <div class="col-4 column">4</div>
  <div class="col-4 column">4</div>
</div>
<div className="grid-demo-row">
  <div class="col-5 column">5</div>
  <div class="col-2 column">2</div>
  <div class="col-5 column">5</div>
</div>
<div className="grid-demo-row">
  <div class="col-6 column">6</div>
  <div class="col-6 column">6</div>
</div>
<div className="grid-demo-row">
  <div class="col-7 column">7</div>
  <div class="col-5 column">5</div>
</div>
<div className="grid-demo-row">
  <div class="col-8 column">8</div>
  <div class="col-4 column">4</div>
</div>
<div className="grid-demo-row">
  <div class="col-9 column">9</div>
  <div class="col-3 column">3</div>
</div>
<div className="grid-demo-row">
  <div class="col-2 column">2</div>
  <div class="col-10 column">10</div>
</div>
<div className="grid-demo-row">
  <div class="col-1 column">1</div>
  <div class="col-11 column">11</div>
</div>
<div className="grid-demo-row">
  <div class="col-12 column">12</div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">{`
.grid-demo-row {
  @include grid();

  margin: 0 auto;

  .column {
    background: transparentize($pink, .5);
    border: 1px solid $azure;
    color: $pink;
    text-align: center;
  }

  @for $i from 1 through 12 {
    .col-#{$i} {
      @include column($i);
    }
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="grid-demo-row">
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                    <div className="col-1 column">1</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-2 column">2</div>
                    <div className="col-2 column">2</div>
                    <div className="col-2 column">2</div>
                    <div className="col-2 column">2</div>
                    <div className="col-2 column">2</div>
                    <div className="col-2 column">2</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-3 column">3</div>
                    <div className="col-3 column">3</div>
                    <div className="col-3 column">3</div>
                    <div className="col-3 column">3</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-4 column">4</div>
                    <div className="col-4 column">4</div>
                    <div className="col-4 column">4</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-5 column">5</div>
                    <div className="col-2 column">2</div>
                    <div className="col-5 column">5</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-6 column">6</div>
                    <div className="col-6 column">6</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-7 column">7</div>
                    <div className="col-5 column">5</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-8 column">8</div>
                    <div className="col-4 column">4</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-9 column">9</div>
                    <div className="col-3 column">3</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-2 column">2</div>
                    <div className="col-10 column">10</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-1 column">1</div>
                    <div className="col-11 column">11</div>
                  </div>
                  <div className="grid-demo-row">
                    <div className="col-12 column">12</div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
